import { ComponentInternalInstance, getCurrentInstance } from 'vue';

type HtmlToPaperGlobalProperties = {
  $htmlToPaper: (elementId: string) => void;
};

export function printHtmlElement(
  elementId: string,
  app?: ComponentInternalInstance | null
) {
  const instance = app ?? getCurrentInstance();
  const htmlToPaper = (
    instance?.appContext.config.globalProperties as unknown as
      | HtmlToPaperGlobalProperties
      | undefined
  )?.$htmlToPaper;

  if (!htmlToPaper) {
    return;
  }

  htmlToPaper(elementId);
}
